export default __webpack_public_path__ + "static/funnels-9d213684e2a704e8fc157ff6387134df.png";